import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import { TextArea } from 'devextreme-react';
import API, { driverDataSource } from '../../../services/AplicationService';
import { showErrorMessage, showSuccessMessage, showConfirmationMessage, handleError } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import * as defaultData from '../../../utils/DefaultData';

const masterProps = {
	title: 'Cadastro de Veículos',
	subtitle: 'Gerencie o cadastro de veículos',
};
const initialState = {
	vehicle: {
		id: null,
		brand: '',
		driverId: null,
		type: '',
		model: '',
		color: '',
		yearOfManucfature: 1950,
		modelYear: 1950,
		maximumWeight: 0,
		description: '',
		enabled: true,
		document: {
			number: '',
		},
	},
	term: '',
};
export default class Vehicle extends Component {
	state = { ...initialState };
	vehicle = {
		id: null,
		brand: '',
		driverId: null,
		type: '',
		model: '',
		color: '',
		yearOfManucfature: 1950,
		modelYear: 1950,
		maximumWeight: 0,
		description: '',
		enabled: true,
		document: {
			number: '',
		},
	};
	constructor(props) {
		super(props);
		this.loadListVehicle = this.loadListVehicle.bind(this);
		this.getVehicle = this.getVehicle.bind(this);
		this.deleteVehicle = this.deleteVehicle.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveVehicle = this.saveVehicle.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getVehicle(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('vehicles/' + key)
			.then(response => {
				this.vehicle = { ...response.data };
				this.setState({ ...this.state, vehicle: this.vehicle });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				console.log(error);
				showErrorMessage(messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteVehicle(key) {
		API.delete('vehicles/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				showErrorMessage(messages.errorDeleteData);
			});
	}
	saveVehicle() {
		this.crudForm.current.showLoadingPanel(true);
		let vehicle = { ...this.vehicle };
		if (vehicle.id === null) {
			API.post('vehicles/', vehicle)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					vehicle = response.data;
					this.vehicle = vehicle;
					this.setState({ vehicle: this.vehicle });
					// console.log(this.vehicle);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('vehicles/' + vehicle.id, vehicle)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.vehicle = vehicle;
					this.setState({ vehicle: this.vehicle });
					//console.log(this.vehicle);
					//this.setState({ vehicle: vehicle });
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					showErrorMessage(messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListVehicle(page, pageSize) {
		let term = this.state.term;
		return API.get('/vehicles', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.vehicles,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				showErrorMessage(messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteVehicle}
					fncGetData={this.getVehicle}
					fncListData={this.loadListVehicle}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{ dataField: 'document.number', caption: 'Placa', width: '10%' },
						{ dataField: 'type', caption: 'Categoria' },
						{ dataField: 'driverName', caption: 'Motorista Padrão' },
						{ dataField: 'brand', caption: 'Marca' },
						{ dataField: 'model', caption: 'Modelo' },
						{ dataField: 'yearOfManucfature', caption: 'Ano Fabrição', width: '10%' },
						{ dataField: 'modelYear', caption: 'Ano Modelo', width: '10%' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						},
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.vehicle = { ...initialState.vehicle };
		this.vehicle.document.number = '';
		this.setState({ ...this.state, vehicle: this.vehicle });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveVehicle();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form formData={this.vehicle} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
				<GroupItem>
					<GroupItem colCount={6}>
						<SimpleItem
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Código' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} />
					</GroupItem>
					<GroupItem colCount={4}>
						<SimpleItem dataField={'document.number'} cssClass="uppercase" label={{ text: 'Placa' }} />
						<SimpleItem
							dataField={'type'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								items: defaultData.categoryVehicle,
								searchEnabled: true,
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Categoria' }}
						/>
						<SimpleItem
							dataField={'brand'}
							editorType={'dxSelectBox'}
							editorOptions={{
								items: defaultData.brandVehicle,
								searchEnabled: true,
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							cssClass="uppercase"
							label={{ text: 'Marca' }}
						/>
						<SimpleItem dataField={'model'} cssClass="uppercase" label={{ text: 'Modelo' }} />

						<SimpleItem dataField={'color'} cssClass="uppercase" label={{ text: 'Cor' }} />
						<SimpleItem
							dataField={'yearOfManucfature'}
							editorType={'dxNumberBox'}
							editorOptions={{ min: 1950, max: 2500 }}
							cssClass="uppercase"
							label={{ text: 'Ano de Fabricação' }}
						/>
						<SimpleItem
							dataField={'modelYear'}
							editorOptions={{ min: 1950, max: 2500 }}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Ano Modelo' }}
						/>
						<SimpleItem
							dataField={'maximumWeight'}
							editorOptions={{
								min: 0,
								max: 9000000000000000,
								format: '#,##0 kg',
							}}
							editorType={'dxNumberBox'}
							cssClass="uppercase"
							label={{ text: 'Carga Máxima' }}
						/>
					</GroupItem>
					<GroupItem colCount={1}>
						<SimpleItem
							dataField={'driverId'}
							editorType={'dxSelectBox'}
							cssClass="uppercase"
							editorOptions={{
								dataSource: driverDataSource,
								searchEnabled: true,
								valueExpr: 'id',
								displayExpr: 'name',
								searchModeOption: 'contains',
								searchTimeoutOption: 200,
								minSearchLengthOption: 2,
								showDataBeforeSearchOption: false,
							}}
							label={{ text: 'Motorista Padrão' }}
						/>
					</GroupItem>
					<GroupItem>
						<SimpleItem
							dataField={'description'}
							editorOptions={{ inputAttr: { rows: 8 } }}
							editorType={'dxTextArea'}
							label={{ text: 'Observação' }}
						/>
					</GroupItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
